<template>
  <div class="page">
    <MyTitle type="1" title="订单统计" class="title-scale"/>
    <div class="flex mt-50">
      <div
        class="list flex flex-direction align-items"
        v-for="(item, index) in list"
        :key="'list' + index"
      >
        <!-- <div class="number">{{ item.number }}</div> -->
        <animate-number
          ref="reNum"
          class="number"
          from="0"
          :to="item.number"
          :key="item.number"
          duration="3000"
        ></animate-number>
        <img
          class="img mt-20"
          :src="require(`@/assets/images/digitalfactory/part-${index + 1}.png`)"
          alt=""
        />
        <div class="label mt-30">
          <span>{{ item.label }}</span>
          <span>{{ item.uuid }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyTitle from '@/views/exposition/components/title2'
export default {
  components: {
    MyTitle,
  },
  data() {
    return {
      list: [
        {
          label: "在线设备数量",
          uuid: "(个)",
          number: 0,
        },
        {
          label: "今日已出货",
          uuid: "(个)",
          number: 0,
        },
        {
          label: "合格率",
          uuid: "(%)",
          number: 0,
        },
      ],
      timer: null,
    };
  },
  mounted() {
    this.list[0].number = this.generateRandomNumber(40, 50);
    let data = 0;
    for (let i = 0; i <= 4; i++) {
      data += this.generateRandomNumber(90, 98);
    }
    this.list[2].number = data / 5;
    this.timer = setInterval(() => {
      this.list[0].number = this.generateRandomNumber(40, 50);
      //   this.list[2].number = this.generateRandomNumber(90, 98);
    }, 60 * 1000);
    let { hours } = this.getTimeFromMidnight();
    this.list[1].number = hours * this.generateRandomNumber(12, 14);
  },
  methods: {
    generateRandomNumber(min, max) {
      var randomNumber = Math.random() * (max - min) + min;
      return Math.floor(randomNumber);
    },
    getTimeFromMidnight() {
      var now = new Date(); // 获取当前时间
      var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate()); // 获取当天0点时间
      var diff = now - midnight; // 计算时间差（单位为毫秒）
      var hours = Math.floor(diff / (1000 * 60 * 60)); // 将时间差转换为小时
      var minutes = Math.floor((diff / (1000 * 60)) % 60); // 将时间差转换为分钟
      var seconds = Math.floor((diff / 1000) % 60); // 将时间差转换为秒钟

      return {
        hours: hours,
        minutes: minutes,
        seconds: seconds,
      };
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style lang="scss" scoped>
@import "./page.scss";
@import "@/assets/scss/comm.scss";
.list {
  width: 321px;
  height: 347px;
  .number {
    font-size: 96px;
    @include ffamily-DS;
    color: $FontColor;
  }
  .img {
    width: 165px;
    height: auto;
  }
  .label {
    font-size: $FontSize40;
  }
}
</style>